import React, {FC, ReactNode} from 'react';
import {QueryClient, QueryClientProvider as ReactQueryClientProvider} from 'react-query';

/*
 * Constants.
 */

export const queryClient = new QueryClient();

/*
 * Components.
 */

export const QueryClientProvider: FC<{children: ReactNode}> = ({children}) => (
  <ReactQueryClientProvider client={queryClient}>{children}</ReactQueryClientProvider>
);

// Augment this type until react-query is upgraded to V4:
// https://github.com/TanStack/query/issues/3476#issuecomment-1092495350
declare module 'react-query' {
  interface QueryClientProviderProps {
    children: ReactNode;
  }
}
